import React from 'react'
import ReactDOM from 'react-dom'
import InfoWindowBox from './InfoWindowBox'
import OutsideAlerter from '../OutsideClicker'
import {markerIcon} from './index'

const OnMarkerClick = (asset, setAsset, map, marker, icon, onclickOpen, nestModal, infowindow, setMarkerColor, history) => {
  const onclickOpenModal = (value) => {
    infowindow.close()
    marker.setIcon(markerIcon(asset, false))
    if (asset !== undefined) {
      setAsset(asset)
    }
    onclickOpen(value)
  }
  
  const closeInfoWindow = () =>{
    infowindow.close()
    marker.setIcon(markerIcon(asset, false))
    marker.open = false
  
  }
  var div = document.createElement("div")
  div.setAttribute("id", "popupContainer")
  ReactDOM.render(
    <OutsideAlerter eventListener='click' onClickOutside={closeInfoWindow} data-test="markerContent">
      <InfoWindowBox markerColorCode={icon.iconStatus} asset={asset} nestModal={nestModal}
        onclickOpen={onclickOpenModal} setMarkerColor={setMarkerColor} history={history}
        closeInfoWindow = {closeInfoWindow}/>
    </OutsideAlerter>
    ,
    div
  )
  infowindow.setContent(div)
  infowindow.open(map, marker)
  marker.open = true
}

export default OnMarkerClick
